import { ReactNode } from 'react';

import { Nullable, SimpleImage, TabItemFields } from '@boss/types/corporate-jobs';

import ComponentMapper from '../ComponentMapper';

export type CorporateTabItem = {
  title?: string;
  icon: Nullable<SimpleImage>;
  color: string;
  content: ReactNode | string;
};

const getCorporateTabItemProps = (entry: TabItemFields, locale: string): CorporateTabItem => {
  const { tabTitle, icon, backgroundColor, content } = entry;

  return {
    title: tabTitle ?? undefined,
    icon: icon
      ? {
          imageAlt: icon.image?.title,
          imageUrl: icon.image?.file?.url,
          id: icon.id,
        }
      : undefined,
    color: backgroundColor?.value,
    content: content ? <ComponentMapper entry={content} locale={locale} /> : null,
  };
};

export default getCorporateTabItemProps;
